let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("2n86z")).then(() => parcelRequire('dycTA'));